import { render, staticRenderFns } from "./VDSL.vue?vue&type=template&id=17297ae4&"
import script from "./VDSL.vue?vue&type=script&lang=js&"
export * from "./VDSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports